
























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import LocalDateTime from '@/types/localdatetime';

@Component
export default class TextBoxDatePicker extends Vue {
	@Prop({ default: '' }) value: any;

	@Prop({ default: false }) disabled: any;

	@Prop() label: any;

	@Prop() max: any;

	@Prop() min: any;

	@Prop() minWidth: any;

	@Prop() rules: any;

	friendlyDateString: string = '';

	dateString: string = '';

	showPicker: boolean = false;

	currentValue: any = '';

	mounted() {
	  if (this.value) {
	    this.onNewValue();
	  }
	}

	@Watch('value')
	onNewValue() {
	  if (this.value && this.value.length > 0) {
	    const localDate: LocalDateTime = new LocalDateTime(this.value);
	    this.friendlyDateString = localDate.toFriendlyDateString();
	    this.currentValue = this.value;
	  } else {
	    this.friendlyDateString = '';
	    this.currentValue = null;
	  }
	}

	onNewDate(date: string) {
	  this.showPicker = false;
	  this.currentValue = date;
	  const localDate: LocalDateTime = new LocalDateTime(date);
	  this.friendlyDateString = localDate.toFriendlyDateString();
	  this.$emit('input', date);
	}
}
